export const RECEIVE_VARIABLE_SERVER = 'RECEIVE_VARIABLE_SERVER';
export const UPDATE_ID_MENU_SELECTED = 'UPDATE_ID_MENU_SELECTED';
export const PRE_SET_SERVICE_LANG = 'PRE_SET_SERVICE_LANG';
export const UPDATE_SESSION_ID = 'UPDATE_SESSION_ID';
export const PRE_SET_SELECTED_DATE = 'PRE_SET_SELECTED_DATE';
export const SET_VARIABLE_SERVER = 'SET_VARIABLE_SERVER';
export const UPDATE_VARIABLE_SERVER = 'UPDATE_VARIABLE_SERVER';
